import { registerPlugin } from '@capacitor/core';
const ProximityReader = registerPlugin('ProximityReader', {
    web: () => import('./web').then((m) => new m.ProximityReaderWeb()),
});
export * from './definitions';
export { ProximityReader };
//# sourceMappingURL=index.js.map